import { useState } from 'react'
import { FTUVerifyCard } from './FTUVerifyCard'
import { FTUEnableTfaCard } from './FTUEnableTfaCard'

export const TfaCard = () => {
  const [qrCodeRead, setQrCodeRead] = useState(false)

  return (
    <>
      {qrCodeRead ? (
        <FTUVerifyCard setQrCodeRead={setQrCodeRead} />
      ) : (
        <FTUEnableTfaCard setQrCodeRead={setQrCodeRead} />
      )}
    </>
  )
}
